module.exports = __webpack_public_path__ + "img/double-chevron.9a1f1d97.svg";